@if (sessionAcquisitions$ | async; as sessionAcquisitions) {
  @if (sessionAcquisitions.length > 0) {
    <!-- Filters -->
    <form class="acquisition-filters form-full-width" [formGroup]="filterFields">
      <mat-checkbox
        test-id="select-all-acquisitions"
        [attr.data-id]="'acquisitions-select-all'"
        [checked]="checkedStatus()?.checked"
        [indeterminate]="checkedStatus()?.indeterminate"
        (change)="checkAcquisition()"
      />
      <span class="filter-field" style="flex: 4">
        <div
          class="sort-icon-wrapper"
          fwTooltip="{{ getFieldTooltip('description') }}"
          fwTooltipPosition="above"
          test-id="file-description-sort"
          (click)="changeSort('description')"
        >
          <fw-sort-icon field="description" [sort]="fileSort" />
        </div>
        <mat-form-field appearance="outline">
          <mat-label>File Name</mat-label>
          <input
            autocomplete="off"
            formControlName="description"
            matInput
            test-id="description-filter"
            type="text"
            [attr.data-id]="'acquisitions-desc-filter'"
          />
        </mat-form-field>
      </span>
      <span class="filter-field" style="flex: 2">
        <div
          class="sort-icon-wrapper"
          fwTooltip="{{ getFieldTooltip('created') }}"
          fwTooltipPosition="above"
          test-id="file-created-sort"
          (click)="changeSort('created')"
        >
          <fw-sort-icon field="created" [sort]="fileSort" />
        </div>
        <mat-form-field appearance="outline">
          <mat-label>Created Date</mat-label>
          <input
            autocomplete="off"
            formControlName="created"
            matInput
            test-id="created-filter"
            type="text"
            [attr.data-id]="'acquisitions-created-filter'"
          />
        </mat-form-field>
      </span>
      <span class="filter-field" style="flex: 2">
        <div
          class="sort-icon-wrapper"
          fwTooltip="{{ getFieldTooltip('classification') }}"
          fwTooltipPosition="above"
          test-id="file-classification-sort"
          (click)="changeSort('classification')"
        >
          <fw-sort-icon field="classification" [sort]="fileSort" />
        </div>
        <mat-form-field appearance="outline">
          <mat-label>Classification</mat-label>
          <input
            autocomplete="off"
            formControlName="classification"
            matInput
            test-id="acquisitions-classification-filter"
            type="text"
            [attr.data-id]="'acquisitions-class-filter'"
          />
        </mat-form-field>
      </span>
      <span class="filter-field" style="flex: 3">
        <div
          class="sort-icon-wrapper"
          fwTooltip="{{ getFieldTooltip('fileType') }}"
          fwTooltipPosition="above"
          test-id="file-type-sort"
          (click)="changeSort('fileType')"
        >
          <fw-sort-icon field="fileType" [sort]="fileSort" />
        </div>
        <mat-form-field appearance="outline" aria-label="File Type">
          <mat-select
            class="muted"
            formControlName="fileType"
            test-id="acquisitions-file-type-select"
            [attr.data-id]="'acquisitions-type-dropdown'"
          >
            <mat-option value="">All Types</mat-option>
            @for (fileType of fileTypes(); track fileType) {
              <mat-option [value]="fileType">{{ fileType }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </span>
      <acquisition-sort [formControl]="sortPanel" />
    </form>
    <!-- Data -->
    <div cdkDropListGroup>
      <!-- Create New Dropzone -->
      @if (!stagedAcquisition()) {
        <div
          cdkDropList
          class="new-acquisition-dropzone"
          [cdkDropListData]="{ acquisition: null }"
          [ngClass]="{ 'cdk-visually-hidden': !(state.fileDragging$ | async) }"
          (cdkDropListDropped)="dropFiles($event)"
        >
          <span class="new-acquisition-placeholder">Drop files here to create a new acquisition</span>
        </div>
      }
      <!-- New Acquisition Staging Area -->
      @if (stagedAcquisition()) {
        <acquisition-files
          cdkDropList
          [acquisition]="$any(stagedAcquisition())"
          [cdkDropListData]="{ acquisition: stagedAcquisition() }"
          [session]="session"
          (cdkDropListDropped)="dropFiles($any($event))"
          (stagedChanged)="stagedAcquisition.set(null); loadAcquisitions()"
        />
      }
      <!-- Acquisitions Saved to the Session -->
      @for (acquisition of sortedAcquisitions$ | async; track getContainerId($index, acquisition)) {
        <acquisition-files
          cdkDropList
          [acquisition]="acquisition"
          [cdkDropListData]="{ acquisition: acquisition }"
          [checked]="isAcquisitionChecked(acquisition._id)"
          [files]="acquisitionFiles.get(acquisition)"
          [session]="session"
          (cdkDropListDropped)="dropFiles($event)"
          (checkedChange)="checkAcquisition(acquisition._id, $event)"
        />
      }
      <!-- Page If > 50 Acquisitions -->
      @if (pagination.total > pagination.limit) {
        <mat-paginator
          [hidePageSize]="true"
          [length]="pagination.total"
          [pageIndex]="pagination.page$.value"
          [pageSize]="pagination.limit"
          [showFirstLastButtons]="true"
          (page)="pagination.page$.next($event.pageIndex)"
        />
      }
    </div>
  } @else {
    <div class="info-message">
      <div class="fab">
        <mat-icon>list</mat-icon>
      </div>
      <p>There are no acquisitions in this session yet.</p>
      <button
        color="primary"
        mat-flat-button
        test-id="add-new-acquisition-button"
        [attr.data-id]="'acquisitions-new-button'"
        (click)="sessionService.createAcquisition(session)"
      >
        Add New Acquisition
      </button>
    </div>
  }
} @else {
  @if (!error()) {
    <div class="loading-state">
      <mat-progress-bar mode="buffer" />
    </div>
  } @else {
    <div class="info-message">
      <div class="fab">
        <mat-icon>error_outline</mat-icon>
      </div>
      <p>Acquisitions could not be retrieved.</p>
      <button color="primary" mat-flat-button test-id="reload-acquisitions-button" (click)="loadAcquisitions()">
        Reload Acquisitions
      </button>
    </div>
  }
}
